<!--The content below is only a placeholder and can be replaced.-->
<div class="app-wrapper lead-generation" [class.payment-failed]="failedPayment" *ngxPermissionsOnly="'INTEGRATION_PERMISSION'">
  <cc-top-bar [title]="projectName || ('LEAD_GENERATION.TOP_BAR.TITLE' | translate)">
<!--    <a routerLink="/lead-generation/new-project">-->
<!--    <cc-top-bar-item-->
<!--      (click)="createNewProject()"-->
<!--      routerLinkActive="primary-hover active" class="menu-item">-->
<!--      <i class="material-icons">note_add</i>-->
<!--      <span translate>LEAD_GENERATION.TOP_BAR.ADD_NEW_LG_PROJECT</span>-->
<!--    </cc-top-bar-item>-->
<!--    </a>-->
  </cc-top-bar>
  <router-outlet></router-outlet>
</div>

